import { UiUtilities } from '@yiluhub/ui-sdk-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { PageHeading } from 'components';
import InteractiveSummaryLayout from 'components/Layout/InteractiveSummaryLayout';
import { LoadingPageAnimation } from 'components/LoadingPageAnimation';
import ProgressBar from 'components/ProgressBar';
import { TravellerInformationForm } from 'components/TravellerInformationForm';

import { LoungeInteractiveProductSummary } from '../../components/LoungeInteractiveProductSummary';
import { useTravellerInputPage } from './hooks';
import './styles.scss';

const TravellerInputPage: React.FC = () => {
  const { t } = useTranslation();
  const { isPageReady, travellerInformationFormProps, productSummaryProps } =
    useTravellerInputPage();
  const isDesktop = UiUtilities.useMediaMatch('--viewport-l');

  return (
    <div className="lounges-tip">
      {isPageReady ? (
        <div className="form-container-wrapper">
          <div className="form-container container">
            <div className="content">
              <ProgressBar />
              <PageHeading text={t('Header - Personal Info')} />
              {productSummaryProps && !isDesktop && (
                <InteractiveSummaryLayout>
                  <LoungeInteractiveProductSummary {...productSummaryProps} />
                </InteractiveSummaryLayout>
              )}
              {travellerInformationFormProps && (
                <TravellerInformationForm {...travellerInformationFormProps} />
              )}
            </div>
            {productSummaryProps && isDesktop && (
              <InteractiveSummaryLayout>
                <LoungeInteractiveProductSummary {...productSummaryProps} />
              </InteractiveSummaryLayout>
            )}
          </div>
        </div>
      ) : (
        <LoadingPageAnimation />
      )}
    </div>
  );
};

export default TravellerInputPage;
